(function () {
  'use strict';

  angular.module('ringbaPortal').directive('htmlPrefixInInput', htmlPrefixInInput);

  function htmlPrefixInInput() {
    const directive = {
      restrict: 'A',
      require: 'ngModel',
      link: link
    };
    return directive;

    function link(scope, element, attrs, controller) {
      function ensureHtmlPrefix(value) {
        if (!value || (value && value.match(/^(h)|(ht)|(htt)|(http)|(https?)|(https?:)|(https?:\/)|(https?:\/\/)/))) {
          return value;
        } else {
          controller.$setViewValue('http://' + value);
          controller.$render();
          return 'http://' + value;
        }
        // keeping the old logic commented out just in case we plan to switch
        // if (value && !/^(https?):\/\//i.test(value) && ('http://'.indexOf(value) === -1 && 'https://'.indexOf(value) === -1)) {
        //   controller.$setViewValue('http://' + value);
        //   controller.$render();
        //   return 'http://' + value;
        // } else {
        //   return value;
        // }
      }
      controller.$formatters.push(ensureHtmlPrefix);
      controller.$parsers.splice(0, 0, ensureHtmlPrefix);
    }
  }
})();
